import appErrorService from '@/services/app/appErrorService';
import {getInstallPrompt} from '@/services/installPromptService';
import log from '@/services/logger/log';
import userBrowserService from '@/services/user/userBrowserService';

const useInstallPwaButton = () => {
    const isTablet = userBrowserService.isTabletDevice();
    const isIosTablet = userBrowserService.isIosDevice() && isTablet;
    const showInstallButton = isTablet && !isIosTablet;

    const onInstallClick = async () => {
        log.info(`Install PWA clicked`);

        const installPrompt = getInstallPrompt();

        if (!installPrompt) {
            log.info(`Install PWA prompt is not available`);
            appErrorService.showGlobalError();
            return;
        }

        log.info(`Install PWA shown`);
        // Show the install prompt
        installPrompt.prompt();

        // Wait for the user to respond to the prompt
        const {outcome} = await installPrompt.userChoice;

        log.info(`User response to the install PWA prompt: ${outcome}`);
    };

    return {showInstallButton, onInstallClick};
};

export default useInstallPwaButton;
